import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

export default function Sidebar({ isOpen, toggleSidebar }) {
  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-top">
        <div className="sidebar-header-row">
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {isOpen ? '−' : '+'}
          </button>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            {isOpen && <span>Home</span>}
          </NavLink>

          <NavLink to="/about" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            {isOpen && <span>About Us</span>}
          </NavLink>

          <NavLink to="/solutions" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            {isOpen && <span>Solutions</span>}
          </NavLink>

          <NavLink to="/contact" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            {isOpen && <span>Contact</span>}
          </NavLink>

          <NavLink to="/login" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
            {isOpen && <span>Client Portal</span>}
          </NavLink>
        </nav>
      </div>
    </aside>
  );
}